import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal } from '@reveni-io/reveni-ui'

import InfoPickingListText from './InfoPickingListText/InfoPickingListText'
import * as Styles from './styles'

const GeneratePickingListModal = ({ show, onClose, onGeneratePickingList, selectedParcels, loading }) => {
  const { t } = useTranslation()

  const handleGeneratePickingList = () => {
    const parcelIds = selectedParcels?.map(parcel => parcel.id)
    onGeneratePickingList(parcelIds)
  }

  return (
    <Modal
      title={t('Lista de recogida')}
      show={show}
      size="l"
      onClose={onClose}
      actions={
        <Styles.ActionsContainer>
          <Button variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={handleGeneratePickingList}
            loading={loading}
            loadingLabel={t('Generando fichero...')}
            defaultLabel={t('Generar fichero')}
            disabled={loading || !selectedParcels?.length}
          />
        </Styles.ActionsContainer>
      }
    >
      <Styles.MainContainer>
        <InfoPickingListText selectedParcels={selectedParcels} />
      </Styles.MainContainer>
    </Modal>
  )
}

export default GeneratePickingListModal
